<template>
  <div
    class="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-200"
  >
    <div class="max-w-7xl mx-auto pt-10 px-4">
      <ModelManager
        @model-created="onModelCreated"
        @model-deleted="onModelDeleted"
        @tenant-not-found="onTenantNotFound"
      />
    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import ModelManager from "@/components/ModelManager.vue";

export default {
  components: {
    ModelManager,
  },
  setup() {
    const router = useRouter();

    const onModelCreated = (model) => {};

    const onModelDeleted = () => {};

    const onTenantNotFound = () => {};

    return {
      onModelCreated,
      onModelDeleted,
      onTenantNotFound,
    };
  },
};
</script>
